// src/icons/MasterCardLogo.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function MasterCardLogo({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 22,
    viewBox: "0 0 36 22",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        d: "M22.9603 2.31934H13.4662V19.3805H22.9603V2.31934Z",
        fill: "#FF5F00"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M14.069 10.8504C14.0675 9.2073 14.4399 7.58539 15.1579 6.10744C15.8759 4.6295 16.9207 3.33427 18.2133 2.31982C16.6126 1.06167 14.6903 0.27924 12.6659 0.0619689C10.6416 -0.155303 8.59703 0.201351 6.76583 1.09116C4.93462 1.98097 3.39071 3.36804 2.31056 5.09382C1.23041 6.81961 0.657593 8.81448 0.657593 10.8504C0.657593 12.8864 1.23041 14.8812 2.31056 16.607C3.39071 18.3328 4.93462 19.7199 6.76583 20.6097C8.59703 21.4995 10.6416 21.8561 12.6659 21.6389C14.6903 21.4216 16.6126 20.6392 18.2133 19.381C16.9207 18.3666 15.8759 17.0713 15.1579 15.5934C14.4399 14.1155 14.0675 12.4935 14.069 10.8504Z",
        fill: "#EB001B"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M35.7684 10.8504C35.7685 12.8863 35.1957 14.8812 34.1156 16.607C33.0355 18.3328 31.4917 19.7198 29.6605 20.6097C27.8293 21.4995 25.7848 21.8561 23.7605 21.6389C21.7362 21.4216 19.8139 20.6392 18.2133 19.381C19.5047 18.3655 20.5487 17.0701 21.2666 15.5924C21.9844 14.1147 22.3574 12.4933 22.3574 10.8504C22.3574 9.20756 21.9844 7.58615 21.2666 6.10845C20.5487 4.63074 19.5047 3.3353 18.2133 2.31982C19.8139 1.06166 21.7362 0.279236 23.7605 0.061967C25.7848 -0.155302 27.8293 0.201358 29.6605 1.09118C31.4917 1.981 33.0355 3.36807 34.1156 5.09386C35.1957 6.81964 35.7685 8.8145 35.7684 10.8504Z",
        fill: "#F79E1B"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M34.7334 17.5735V17.2242H34.8742V17.153H34.5155V17.2242H34.6564V17.5735H34.7334ZM35.4297 17.5735V17.1523H35.3198L35.1933 17.442L35.0668 17.1523H34.9568V17.5735H35.0345V17.2558L35.1531 17.5297H35.2336L35.3522 17.2551V17.5735H35.4297Z",
        fill: "#F79E1B"
      })
    ]
  });
}
export {
  MasterCardLogo
};
//# sourceMappingURL=MasterCardLogo.mjs.map